import { Box, IconButton, Typography, Snackbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useState } from 'react';

interface IGenerationProps {
  generation: string;
}

const Generation: React.FC<IGenerationProps> = ({ generation }) => {
  const theme = useTheme();
  const [message, setMessage] = useState('');

  const showSnackbarMessage = (message: string, timeout = 1000) => {
    setMessage(message);

    setTimeout(() => {
      setMessage('');
    }, timeout);
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(generation)
      .then(() => {
        showSnackbarMessage('Скопировано');
      })
      .catch((e) => console.log('error:', e));
  };
  return (
    <Box
      sx={{
        position: 'relative',
        padding: '20px 35px 20px 20px',
        '&:hover': {
          background: theme.custom.palette.primary.background,
        },
      }}
    >
      <IconButton
        size={'small'}
        onClick={handleCopy}
        sx={{
          position: 'absolute',
          top: '5px',
          right: '15px',
        }}
      >
        <FileCopyIcon sx={{ fontSize: '16px' }} color={'primary'} />
      </IconButton>
      <Typography variant="h5" sx={{ cursor: 'default', whiteSpace: 'pre-line' }}>
        {generation}
      </Typography>

      {message && (
        <Snackbar
          open={true}
          style={{
            padding: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100px',
          }}
          ContentProps={{
            style: {
              padding: 0,
              display: 'flex',
              justifyContent: 'center',
              background: theme.custom.palette.primary.default,
              boxShadow: '0 5px 5px -2px rgba(0,0,0,0.1)',
              fontSize: '12px',
              color: theme.custom.palette.primary.white,
            },
          }}
          message={message}
        />
      )}
    </Box>
  );
};

export default Generation;
